module.exports = __webpack_public_path__ + "img/ambulans.104712d6.svg";